import styles from './page8.module.css';
import '../../../website-mobile/mobile-scope.css';

const YT_ID = '61iN2emMqbs';
const YT_WALKTHROUGH = `https://www.youtube.com/embed/${YT_ID}?rel=0&playsinline=1`;

export default function Page8({ handleBtnClick }) {
    return (
        <div className={`${styles.page8} website-mobile-scope`}>
            <div className={styles.bgLines}>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
            </div>

            <div className={styles.contentWrapper}>
                <div className={styles.ctaWrapper}>
                    <h2 className={styles.heading}>Your next step</h2>
                    <p className={styles.subheading}>
                        Book a conversation with our school specialist
                    </p>
                    <div className={styles.ctaWrap}>
                        <button
                            onClick={(e) => handleBtnClick(e.target, "Try School Ai CTA")}
                            className={`wm-btn-primary ${styles.ctaButton}`}
                        >
                            Book Walkthrough
                        </button>
                    </div>
                </div>
                <div className={styles.videoFrame}>
                    <iframe
                        className={styles.video}
                        src={YT_WALKTHROUGH}
                        title="Product walkthrough for CoSchool"
                        allow="encrypted-media; picture-in-picture"
                        allowFullScreen
                    />
                </div>
                <p className={styles.videoLabel}>Click Above to Watch</p>
            </div>
        </div>
    );
}